const toggleStyleElement = (selector: string, hide?: boolean) => {
  const styleElement = document.querySelector(selector);
  if (styleElement && styleElement instanceof HTMLStyleElement) {
    // If hide is undefined, toggle based on the current state
    const shouldHide = hide === undefined ? !styleElement.hasAttribute('media') : hide;

    if (shouldHide && !styleElement.hasAttribute('media')) {
      styleElement.setAttribute('media', 'not all');
    } else if (!shouldHide && styleElement.hasAttribute('media')) {
      styleElement.removeAttribute('media');
    }
  }
};
export default toggleStyleElement;
